import { render, staticRenderFns } from "./Regulation.vue?vue&type=template&id=09ae4d05&scoped=true"
import script from "./Regulation.vue?vue&type=script&setup=true&lang=ts"
export * from "./Regulation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Regulation.vue?vue&type=style&index=0&id=09ae4d05&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ae4d05",
  null
  
)

export default component.exports